import { render, staticRenderFns } from "./SchoolTransactionsPageListItem.vue?vue&type=template&id=62234704&scoped=true&lang=pug&"
import script from "./SchoolTransactionsPageListItem.vue?vue&type=script&lang=js&"
export * from "./SchoolTransactionsPageListItem.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTransactionsPageListItem.vue?vue&type=style&index=0&id=62234704&lang=scss&scoped=true&"
import style1 from "./SchoolTransactionsPageListItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62234704",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
